import { render, staticRenderFns } from "./AboutItem.vue?vue&type=template&id=99b63070&scoped=true&"
import script from "./AboutItem.vue?vue&type=script&lang=js&"
export * from "./AboutItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b63070",
  null
  
)

export default component.exports